// extracted by mini-css-extract-plugin
export default {"pageTitle":"roundPositionCell_pageTitle__AT6mo","roundPosition":"roundPositionCell_roundPosition__iXbt0"};